import { useQuery } from '@tanstack/react-query';
import { assetActions } from 'actions/asset';
import type { AssetInspectionRecord } from 'actions/asset';

const EMPTY_INSPECTION_RECORDS: readonly AssetInspectionRecord[] = [];

const useFetchInspectionRecord = (
  id: number,
  assetHubRefreshToken: number,
) => {
  const refreshData = assetHubRefreshToken > 0;
  const { data, isLoading, isError } = useQuery({
    queryKey: ['inspectionRecords', id, assetHubRefreshToken],
    queryFn: async () => {
      const result = await assetActions().getInspectionRecords(
        id,
        refreshData,
      );
      return result || [];
    },
    enabled: id > 0,
    gcTime: 60 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const inspectionsAvailable = !!data && data.length > 0;
  const inspectionRecords = data ?? EMPTY_INSPECTION_RECORDS;

  return { inspectionsAvailable, inspectionRecords, isLoading, isError };
};

export default useFetchInspectionRecord;
